import { render, staticRenderFns } from "./consulta.vue?vue&type=template&id=42bd2f8e&scoped=true&"
import script from "./consulta.vue?vue&type=script&lang=js&"
export * from "./consulta.vue?vue&type=script&lang=js&"
import style0 from "./consulta.vue?vue&type=style&index=0&id=42bd2f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd2f8e",
  null
  
)

export default component.exports